import {
  jsx as reactJsx,
  jsxs as reactJsxs,
  jsxDEV as reactJsxDEV,
} from "react-native-css-interop/jsx-runtime";
import { wrap } from "../../wrap";
import { interop } from "./interop";
import html from "../../html";

interop(html);

export const jsx = wrap(reactJsx);
export const jsxs = wrap(reactJsxs);
export const jsxDEV = wrap(reactJsxDEV);

export { Fragment, createElement } from "react";
